import { useState, useCallback, memo, useMemo } from 'react';
import { connect } from 'react-redux';
import UpIcon from '@mui/icons-material/ArrowUpwardRounded';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import DownIcon from '@mui/icons-material/ArrowDownwardRounded';
import ClearIcon from '@mui/icons-material/DeleteForeverRounded';
import DuplicateIcon from '@mui/icons-material/FilterNoneRounded';
import { createActions } from '../../../store';
import WaveLayerContent from './WaveLayerContent';
import WaveLayerActions from './WaveLayerActions';
import WaveLayerHeader from './WaveLayerHeader';

const WaveLayer = memo(({
    classes,
    waveCircle,
    index,
    title,
    maxLineWidth,
    advanced,
    remove,
    moveUp,
    moveDown,
    duplicate,
    updateWaveLayer,
    waveLayerLineWidth,
    ...domProps
}) => {
    const [open, setOpen] = useState(false);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  
    const toggleVisibility = useCallback(() => {
        updateWaveLayer(index, { visible: waveCircle.visible ? false : true });
    }, [waveCircle.visible]);

    const actions = useMemo(() => [
        { label: 'Duplicate', icon: <DuplicateIcon />, onClick: duplicate },
        { label: waveCircle.visible ? 'Hide' : 'Show', icon: waveCircle.visible ? <VisibilityIcon /> : <VisibilityOffIcon />, onClick: toggleVisibility },
        { label: 'Move Down', icon: <DownIcon />, onClick: moveDown },
        { label: 'Move Up', icon: <UpIcon />, onClick: moveUp },
        { label: 'Remove', icon: <ClearIcon />, onClick: remove },
    ], [duplicate, moveDown, moveUp, remove, waveCircle.visible, toggleVisibility]);

    const handleAction = useCallback((action) => {
        setMenuAnchorEl(null);
        action();
    }, []);

    const handleMoreClick = useCallback((event) => {
        event.stopPropagation();
        setMenuAnchorEl(event.currentTarget);
    }, []);

    const handleClose = useCallback(() => {
        setMenuAnchorEl(null);
    }, []);

    const toggleOpen = useCallback(() => {
        setOpen(prev => !prev);
    }, []);

    return (
        <>
            <WaveLayerHeader
                title={title}
                open={open}
                onClick={toggleOpen}
                advanced={advanced}
                onMoreClick={handleMoreClick}
                index={index}
                {...domProps}
            />
            <WaveLayerActions
                actions={actions.map(action => ({
                    ...action,
                    onClick: action.onClick ? () => handleAction(action.onClick) : null
                }))}
                anchorEl={menuAnchorEl}
                onClose={handleClose}
            />
            <WaveLayerContent
                open={open}
                index={index}
                advanced={advanced}
                waveLayerLineWidth={waveLayerLineWidth}
            />
        </>
    );
});

const mapStateToProps = (state, { index }) => ({
    waveCircle: state.createPreview.present.videoSettings.visualizer.waveCircles[index],
    maxLineWidth: state.createPreview.present.videoSettings.visualizer.maxLineWidth,
    waveLayerLineWidth: state.createPreview.present.videoSettings.visualizer.waveCircles[index].lineWidth
});

const mapDispatchToProps = (dispatch) => {
    const removeWaveLayer = (index) => dispatch(createActions.removeWaveLayer(index));
    const duplicateWaveLayer = (index) => dispatch(createActions.duplicateWaveLayer(index));
    const updateWaveLayer = (index, properties) =>  dispatch(createActions.updateWaveLayer(index, properties));
    const changeWaveLayerOrder = (firstIndex, secondIndex) => dispatch(createActions.changeWaveLayerOrder(firstIndex, secondIndex));

    return {
        removeWaveLayer,
        duplicateWaveLayer,
        changeWaveLayerOrder,
        updateWaveLayer
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayer);